module.exports = __webpack_public_path__ + "da6820a543d603d18ce32b3348dc30da.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-19.png
// module id = 2098
// module chunks = 0